import React from "react";
import { Redirect, Route } from "react-router-dom";
import useAuthStore from "../store/authStore";
import ErrorBoundary from "../Components/ErrorBoundary";

function ProtectedRoute({ component: Component, ...rest }) {
    const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
    const userRole = useAuthStore((state) => state.role);

    return (
        <Route
            {...rest}
            render={(props) =>
                isAuthenticated && userRole === "admin" ? (
                    <ErrorBoundary>
                        <Component {...props} />
                    </ErrorBoundary>
                ) : (
                    <Redirect to="/login" />
                )
            }
        />
    );
}

export default ProtectedRoute;
